<template>
   <v-layout v-if="viewAll">
      <v-navigation-drawer location="right" v-model="drawer" temporary v-if="drawer">
         <v-card style="width: 50vw;">
            <IndexView v-if="viewId" :itemId="viewId" :processView="indexView" />
         </v-card>
      </v-navigation-drawer>
      <v-main style="width: 0px !important;">
         <div class="container">
            <div class="text-h6 font-weight-bold mb-2">Process Lead Dashboard</div>

            <SelectionFilter class="mb-2" @selected-values="handleQuickFilterValues" />

            <div style="display:flex;flex-wrap: wrap;">

               <div v-if="showAccount" style="width:290px;float: left">
                  <v-card flat class="pa-2 mb-2" style="display:flex;justify-content:space-between;height: 40px; width: 278px;">
                     <div style="width:100%;display: flex;">
                        <button id="activator" class="d-flex pt-1">
                           <v-icon class="">mdi-filter-outline</v-icon>

                           <v-menu activator="parent" v-model="menu" transition="scale-transition" :close-on-content-click="false"
                              location="bottom">
                              <v-list width="300px">
                                 <DashboardFilter :type="'openIssue'" :process="true" :existFilterData="dashboardFilterData" @applyChange="handleDashboardFilterValues"
                                    @close="filterDialog = false" />
                              </v-list>
                           </v-menu>
                        </button>
                        
                         <span class="text-subtitle-1 font-weight-bold mb-2">Open Tasks &nbsp; ({{ UnAssignedIssuesCount }})</span>
                       
                     </div>
                     <div style="align-items:flex-end">
                        <span ref="searchContainer" v-if="searchClicked">
                           <TextFieldComponent id="search" v-model="search" flat append-inner-icon="mdi-magnify">
                           </TextFieldComponent>
                        </span>
                        <v-icon style="align-items:flex-end" v-else  @click.stop="toggleSearch">mdi-magnify</v-icon>
                                              
                     </div>
                  </v-card>
                  <UnAssignedIssues :filterData="filterData" :searchData="search" @draweView="openView" 
                  @open-issue-update="setUnAssignedIssue"/>
               </div>

               <div v-bind:class="dynamicClass" >
                  <v-card flat class="pa-1 mb-2" style="display: flex;align-items: center; justify-content: space-between;">
                     <div class="text-subtitlte-1 pa-1 font-weight-bold mb-2">
                        Tasks from Current shift</div>
                     <div class="section-controls">
                        <v-tooltip location="bottom" :text="showWorkload ? 'Hide Workload' : 'Show Workload'">
                           <template v-slot:activator="{ props }">
                              <div v-bind="props" :class="['toggle-pill', showWorkload ? 'toggle-pill--active' : '']"
                                 @click="showWorkload = !showWorkload">
                                 <v-icon size="15">mdi-account-group-outline</v-icon>
                                 <span>Workload</span>
                              </div>
                           </template>
                        </v-tooltip>
                        <v-tooltip location="bottom" :text="isMaximized ? 'Minimize' : 'Maximize'">
                           <template v-slot:activator="{ props }">
                              <v-icon class="iconToggle ml-2" v-bind="props" @click="toggleMaximize">
                                 {{ isMaximized ? 'mdi-window-minimize' : 'mdi-window-maximize' }}
                              </v-icon>
                           </template>
                        </v-tooltip>
                     </div>
                  </v-card>
                  <ProcessBoard :maxValue="showOnly" :filterData="filterData" @draweView="openView" />
                  <v-card  flat v-if="showAll" style="text-align: left;" 
                  class="pa-1 text-subtitle-1 font-weight-bold my-3">
                  Task from other Shifts
               </v-card>
                  <UserByShifts v-if="showAll" :filterData="filterData" @draweView="openView" />
               </div>


               <div v-if="showWorkload">
                  <v-card flat class="pa-2 mb-2" style="display: flex; justify-content: space-between; align-items: center;">
                     <span class="text-subtitle-1 font-weight-bold">
                        <v-icon v-if="selectedAccount" size="18" class="cursor-pointer iconToggle mr-1" @click="selectedAccount = null">mdi-arrow-left</v-icon>
                        {{ selectedAccount ? selectedAccount.account_name : 'Workload in All Accounts' }}
                     </span>
                  </v-card>
                  <AllAccountsWork v-if="!selectedAccount" :selectedAccountId="null" @account-selected="onAccountSelected" />
                  <AllWorkSpaceUser v-if="selectedAccount" :accountId="selectedAccount.account_id" @openlistview="showIssueForUser" />
               </div>
            </div>

         </div>
         <v-dialog persistent v-model="showlistview" style="z-index=900">
            <v-card>
               <v-card-title>
                  <span >
                  <CustomAvatar2 v-if="false" :size="'small'" 
                :fName="selectedUser.first_name" 
                :lName="selectedUser.last_name" 
                :theme="selectedUser.theme" 
                :imgUrl="selectedUser.image_url ? selectedUser.image_url: null"/>
               </span>
               {{  selectedUser.first_name }} {{ selectedUser.last_name }} Open Tasks
                  <v-icon @click="showlistview=false" class="float-right mdi mdi-close"/>
                  
               </v-card-title>
               <v-card-text>         
                  
                  <ListView   :issueData="userIssues"/>
            </v-card-text>
            </v-card>
         </v-dialog>
      </v-main>
   </v-layout>
</template>

<script>
import CustomAvatar2 from '@/components/ui/CustomAvatar2.vue';

import DashboardFilter from '../Widgets/DashboardFilter.vue'
import AllAccountsWork from './AllAccountsWork.vue'
import AllWorkSpaceUser from './AllWorkSpaceUser.vue'
import UnAssignedIssues from './UnAssignedIssues.vue'
import ProcessBoard from './ProcessBoard.vue'
import SelectionFilter from './SelectionFilter.vue'
import UserByShifts from './UserByShifts.vue'
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import IndexView from '@/modules/issues/views/Index.vue'
import ListView from '@/modules/issues/List.vue'
import IssueService from '@/api/service/Issue/IssueService'
// import AllAccountsWork from './AllAccountsWork.vue';
export default {
   components: {
      DashboardFilter,
      CustomAvatar2,
      ListView,
      UnAssignedIssues,
      SelectionFilter,
      ProcessBoard,
      AllAccountsWork,
      AllWorkSpaceUser,
      UserByShifts,
      TextFieldComponent,
      IndexView
   },
   data() {
      return {
         selectedUser:{},
         userIssues:[],
         showlistview:false,
         UnAssignedIssuesCount:0,
         searchClicked: false,
         viewAll: false,
         menu:false,
         indexView: false,
         viewId: null,
         drawer: false,
         search: null,
         showAll: true,
         showOnly: true,
         showAccount: true,
         showWorkload: false,
         isMaximized: false,
         selectedAccount: null,
         selectedValues: {},
         filterData: {},
         quickFilterData: {},
         dashboardFilterData: {},
         wsDefaults: null
      }
   },
   watch: {
      refreshOnUser() {
         if (this.refreshOnUser) {
            this.openView()
         } else {
            this.openView()
         }
      }
   },
   computed: {
      refreshOnUser() {
         return this.$store.getters.getAssignee;
      },
      dynamicClass() {
         if (this.isMaximized) return 'fullBoardSection'
         const sidesVisible = (this.showAccount ? 1 : 0) + (this.showWorkload ? 1 : 0)
         if (sidesVisible === 0) return 'boardSection'
         if (sidesVisible === 1) return 'allBoardSection'
         return 'defaultBoardSection'
      },
   },
   created() {
      this.wsDefaults = localStorage.getItem("_WS_DEFAULTS_");
      if (this.wsDefaults) {
         this.wsDefaults = JSON.parse(this.wsDefaults);
         if (!this.wsDefaults.workspace) {
            this.getSelectselectValue(this.wsDefaults)
            return;
         }
      } else {
         this.getSelectselectValue(this.wsDefaults)
         return;
      }
      this.viewAll = true
      let excitsFilter = localStorage.getItem("filterData");
      if(excitsFilter){
         this.dashboardFilterData = JSON.parse(excitsFilter)
         this.filterData = { ...this.dashboardFilterData }
      }

   },
   methods: {
      async showIssueForUser($user) {
         this.selectedUser = $user
         let $res = await IssueService.findAllIssues({next_action:$user.id});
         let notInStage = [
            'completed',
            'closed',
            'qapending',
            'clarification',
            'itsupportrequired',
            'itsupport',
            'it_support',
            'hold',
            'cancel',
            'errorlog'
         ];
         let $data = [] 
         for(let item of $res){
            const st = (item.stage || '').toLowerCase().trim().replace(/[\s_]+/g, '');
            if(!notInStage.includes(item.stage) && !notInStage.includes(st)){
               $data.push(item)
            }
         }
         this.userIssues= $data
         this.showlistview=true
      }, 
      setUnAssignedIssue(data) {
         this.UnAssignedIssuesCount = typeof data === "number" ? data : (data && data.length ? data.length : 0);
      },
      getSelectselectValue() {
         this.$store.dispatch("setSnackbar", {
            text: "Please Select Workspace/Account/Project first",
         });
         this.$router.push("/showWorkspaces");
         localStorage.setItem("_WS_REDIRECT_", '/dashBoard/processLead')
      },
      openView(item) {
         let status = this.$store.getters.getMyspace;
         localStorage.setItem("_WS_DEFAULTS_", JSON.stringify({ "workspace": { "id": item.work_space_id, "name": item.work_space_name } }))
         localStorage.setItem("workSpaceId", item.work_space_id);

         // this.$router.push({ path: "/issueView2", query: { id: item.id } });
         this.$store.dispatch('setIssueInView', item.id)
         let wsDefaults = {
            workspace: { id: item.work_space_id, name: item.work_space_name },
            account: { id: item.account_id, name: item.account_name },
            project: { id: item.project_id, name: item.project_name }
         }
         let wsDefaultsData = JSON.stringify(wsDefaults)
         localStorage.setItem("_WS_DEFAULTS_", wsDefaultsData);
         // console.log(wsDefaultsData,'alert111111111')
         this.$store.commit("SET_REFRESH_BREADCRUMP", true)
         this.$store.commit("CHANGE_MY_SPACE", !status);
      },
      onAccountSelected(account) {
         this.selectedAccount = this.selectedAccount && this.selectedAccount.account_id === account.account_id ? null : account
      },
      toggleMaximize() {
         this.isMaximized = !this.isMaximized
         this.showOnly = this.isMaximized
         if (this.isMaximized) {
            this._prevShowAccount = this.showAccount
            this._prevShowAll = this.showAll
            this._prevShowWorkload = this.showWorkload
            this.showAccount = false
            this.showAll = false
            this.showWorkload = false
         } else {
            this.showAccount = this._prevShowAccount ?? true
            this.showAll = this._prevShowAll ?? true
            this.showWorkload = this._prevShowWorkload ?? false
         }
      },
      closeAll() {
         this.showAll = !this.showAll
      },
      handleQuickFilterValues(data) {
         this.quickFilterData = data || {};
         this.updateCombinedFilter();
      },
      handleDashboardFilterValues(data) {
         this.menu = false;
         this.dashboardFilterData = data || {};
         localStorage.setItem('filterData', JSON.stringify(this.dashboardFilterData));
         this.updateCombinedFilter();
      },
      handleSelectedValues(data) {
         this.handleDashboardFilterValues(data);
      },
      updateCombinedFilter() {
         let combined = { ...this.dashboardFilterData, ...this.quickFilterData };
         Object.keys(combined).forEach(key => {
            if (combined[key] === null || combined[key] === undefined || combined[key] === '') {
               delete combined[key];
            }
         });
         this.filterData = combined;
      },
      toggleAccount() {
         this.showAccount = !this.showAccount
      },
      toggleAll() {
         this.showAll = !this.showAll
      },

      toggleSearch() {
         this.searchClicked = !this.searchClicked;
         if (this.searchClicked) {
            document.addEventListener('click', this.handleOutsideClick);
         } else {
            document.removeEventListener('click', this.handleOutsideClick);
         }
      },
      handleOutsideClick(event) {
         const textField = this.$refs.searchContainer;
         if (textField && !textField.contains(event.target)) {
            this.searchClicked = false;
            document.removeEventListener('click', this.handleOutsideClick);
         }
      },
   }
}
</script>

<style scoped>
.section-controls {
   display: flex;
   gap: 6px;
   align-items: center;
}

.toggle-pill {
   display: flex;
   align-items: center;
   gap: 5px;
   padding: 4px 12px;
   border-radius: 20px;
   font-size: 12px;
   font-weight: 500;
   cursor: pointer;
   color: #7a8a9a;
   background: #ffffff;
   border: 1px solid #dde3ea;
   transition: all 0.2s ease;
   user-select: none;
   white-space: nowrap;
   box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.toggle-pill:hover {
   background: #f0f5ff;
   color: #1258ab;
   border-color: #a8c4f0;
   box-shadow: 0 2px 6px rgba(18, 88, 171, 0.12);
}

.toggle-pill--active:hover {
   background: linear-gradient(135deg, #0e4a96, #1a65c4);
   color: #ffffff !important;
   border-color: transparent;
   box-shadow: 0 4px 10px rgba(18, 88, 171, 0.4);
}

.toggle-pill--active {
   background: linear-gradient(135deg, #1258ab, #2176d9);
   color: #ffffff !important;
   border-color: transparent;
   box-shadow: 0 3px 8px rgba(18, 88, 171, 0.3);
   font-weight: 600;
}

.toggle-pill--active .v-icon {
   color: #ffffff !important;
}

.control-btn {
   font-size: 12px;
   text-transform: none;
   letter-spacing: 0;
}

.container {
   background: #f2f7fd;
   padding: 10px 20px;
   height: 90vh;
   width: 100%;
   overflow-x: auto;
}

.defaultBoardSection {
   max-width: calc(100% - 580px);
   overflow: auto;
   margin-right: 15px;
}

.allBoardSection {
   max-width: calc(100% - 340px);
   overflow: auto;
   margin-right: 15px;
}

.fullBoardSection {
   width: 100%;
   overflow: auto;
   margin-right: 0;
}

.boardSection {
   max-width: 94vw;
   overflow: auto;
   margin-right: 15px;
}
>>>.v-field {
    background: #fff;
    width: 320px !important;
    margin-right: 4px;
    z-index: 3;
}


.iconToggle:hover {
   color: #1258ab !important;
}

>>>.v-navigation-drawer {
   width: 50% !important;
   position: absolute !important;
   top: 72px !important;
   height: 90vh !important;
}

>>>::-webkit-scrollbar {
    width: 6px;
    height:6px;
}

>>>::-webkit-scrollbar:hover {
    width: 10px;
    height: 10px;
}

>>>::-webkit-scrollbar-track {
    background: #e8f3f9;
}

>>>::-webkit-scrollbar-thumb {
    background: rgb(0, 0, 0, 0.12);
    border-radius: 8px;
}

</style>